// Function to check if we're in production
export const isProduction = () => {
  const hostname = window.location.hostname;
  return hostname.includes("jawdaplus.net");
};

// Function to get tenant ID from URL
export const getTenantId = () => {
  const hostname = window.location.hostname;
  // Extract subdomain (e.g., 'tenant1' from 'tenant1.jawdaplus.net')
  const subdomain = hostname.split(".")[0];
  return subdomain;
};

// Function to detect environment
export const getEnvironment = () => {
  const hostname = window.location.hostname;
  if (hostname.includes("jawdaplus.net")) {
    return "production";
  } else if (hostname.includes("localhost") || hostname.includes("127.0.0.1")) {
    return "development";
  } else if (hostname.includes("staging")) {
    return "staging";
  }
  return "other";
};

// Umami analytics website IDs per environment, then per tenant
const UMAMI_WEBSITE_IDS = {
  production: {
    // *.jawdaplus.net
    base: "c1761e5e-b718-4f2a-ad88-b18dc4401eb9",
    hb: "7b843241-cb53-4164-b2ea-a1eb5a556b5f",
    palmary: "9348dfe1-ba19-454c-9f9e-20907019f49f",
    dulcesol: "7f30f385-51c7-4fbc-b7c3-b3d7ead02923",
    henkeldz: "9b51072f-5868-4b24-87be-d8dd6a78e2fd",
    ifri: "80714459-2ccb-40bc-8b3a-e9a8eea68e81",
    rouiba: "b080df18-0ddd-480c-88bf-6b109714c7f0",
    hayat: "d21c76aa-befc-4239-977a-9f0f734f86b0",
    swalis: "86b91b2a-a939-4615-852c-eece191012cc",
  },
  test: {
    // *.jawdaplus.click
    base: "23447929-97fa-4fb3-b2df-4939aef33191",
    hb: "07145849-3f10-4676-b1ab-595ab170e16c",
    palmary: "cc22d74f-79c9-4006-806d-bfd7612c7571",
    dulcesol: "7c5adf4a-13d1-4000-82b2-90fc70172d06",
    henkeldz: "1a59785c-c49e-42c5-b093-c52a7de98348",
    ifri: "6f2168e6-3b18-4d1f-895e-0192cb73f9d9",
    rouiba: "f96f16e2-4176-4e24-844a-cc73ade6ab02",
    hayat: "327b3a16-b7dd-4198-a613-e6777f3ecde6",
    swalis: "8ffb57f1-62a8-47f8-90ec-f722cb13a89b",
  },
};

// Initialize Umami analytics for the current tenant
export const initUmami = (tenantName) => {
  const hostname = window.location.hostname;

  let env;
  if (hostname.includes('jawdaplus.net')) {
    env = 'production';
  } else {
    env = 'test';
  } 

  const websiteId = UMAMI_WEBSITE_IDS[env]?.[tenantName];
  if (!websiteId) return;

  // Avoid injecting the script more than once
  if (document.querySelector('script[data-website-id]')) return;

  const script = document.createElement('script');
  script.defer = true;
  script.src = 'https://state.jawdaplus.click/script.js';
  script.setAttribute('data-website-id', websiteId);
  document.head.appendChild(script);
};

// Initialize Google Analytics
export const initGA = () => {
  // Only initialize for production domains
  if (!isProduction()) {
    console.log("GA not loaded - not in production domain");
    return;
  }

  const gaId = "G-YXZFJYD59M";

  // Load gtag script
  const script = document.createElement("script");
  script.src = `https://www.googletagmanager.com/gtag/js?id=${gaId}`;
  script.async = true;
  document.head.appendChild(script);

  // Initialize gtag
  window.dataLayer = window.dataLayer || [];
  function gtag() {
    window.dataLayer.push(arguments);
  }
  window.gtag = gtag;

  gtag("js", new Date());

  // Configure GA with custom dimensions
  gtag("config", gaId, {
    cookie_domain: "auto",
    cookie_flags: "SameSite=None;Secure",
    custom_map: {
      dimension1: "tenant_id",
      dimension2: "environment",
    },
  });

  // Send initial page view with tenant info
  trackPageView();

  console.log("GA initialized for tenant:", getTenantId());
};

// Track page views with tenant info
export const trackPageView = (path = window.location.pathname) => {
  if (!isProduction() || !window.gtag) return;

  window.gtag("event", "page_view", {
    tenant_id: getTenantId(),
    environment: getEnvironment(),
    page_location: window.location.href,
    page_path: path,
  });
};

// Track custom events with tenant info
export const trackEvent = (eventName, eventParams = {}) => {
  if (!isProduction() || !window.gtag) return;

  window.gtag("event", eventName, {
    tenant_id: getTenantId(),
    environment: getEnvironment(),
    ...eventParams,
  });
};
